import axios from 'axios';
import { handleResponse } from './HelperService';

const getAllMITransactions = (params, onSuccess, onError) => {
    const response = axios.get('v1/service-layer/milog', {params});
    return handleResponse(response, onSuccess, onError);
};


const getAllMHCTransactions = (params, onSuccess, onError) => {
    const response = axios.get('v1/service-layer/log', {params});
    return handleResponse(response, onSuccess, onError);
};


export {getAllMITransactions, getAllMHCTransactions}